<template>
  <main-layout>
    <template #header>
      <main-header :title="'ERP 사용신청' | translate" />
    </template>
    <template #feature />
    <template #toolbar />
    <v-data-table :headers="headers" :items="items" :loading="loading" item-key="applicationId">
      <template #item.actions="{ item }">
        <v-btn v-if="item.status === 'REQUESTED'" small color="primary" class="mr-2" @click="approve(item)">승인</v-btn>
        <v-btn v-if="item.status === 'REQUESTED'" small class="mr-2" @click="reject(item)">거절</v-btn>
        <v-btn v-if="canReinvite(item.status)" small @click="reinvite(item)">재발송</v-btn>
      </template>
    </v-data-table>
  </main-layout>
</template>

<script>
import {PATH} from "@/constants";

export default {
  name: "ErpApplicationList",
  data() {
    return {
      items: [],
      loading: false,
      headers: [
        {text: "신청", value: "applicationId"},
        {text: "임대업체", value: "companyName"},
        {text: "사용자", value: "userLoginId"},
        {text: "상태", value: "status"},
        {text: "테넌트", value: "companyId"},
        {text: "", value: "actions", sortable: false},
      ],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    canReinvite(status) {
      return status === "INVITE_SENT" || status === "APPROVED" || status === "FAILED";
    },
    load() {
      this.loading = true;
      this.$request(PATH.ERP_ACCESS.LIST)
        .catch()
        .enqueue()
        .then((res) => {
          this.items = (res && res.applications) || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    approve(item) {
      this.$request(PATH.ERP_ACCESS.APPROVE + item.applicationId + "/approve")
        .setObject({})
        .enqueue()
        .then(() => this.load());
    },
    reject(item) {
      const reason = window.prompt("거절 사유") || "";
      this.$request(PATH.ERP_ACCESS.REJECT + item.applicationId + "/reject")
        .setObject({reason})
        .enqueue()
        .then(() => this.load());
    },
    reinvite(item) {
      this.$request(PATH.ERP_ACCESS.REINVITE + item.applicationId + "/reinvite")
        .setObject({})
        .enqueue()
        .then(() => this.load());
    },
  },
};
</script>
